import {
  Home,
  LayoutDashboard,
  Flame,
  LucideIcon
} from "lucide-react";

export interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
}

export const navigationItems: NavItem[] = [
  {
    label: "Dashboard",
    href: "/",
    icon: LayoutDashboard
  },
  {
    label: "Home",
    href: "/home",
    icon: Home
  },
  {
    label: "Devnet Campaign",
    href: "/elitra-devnet",
    icon: Flame
  },
];
